module.exports = __webpack_public_path__ + "static/media/kia-headset.c2ce88b8.svg";